import { tool } from "ai";
import { z } from "zod";
import type { AppAgentActions } from "./hooks/app-agent-context";

const navigateDestinationSchema = z.enum([
	"home",
	"library",
	"whiteboards",
	"trash",
	"draft",
	"profile",
	"whiteboard",
	"card",
]);

export function createAppTools({ actions }: { actions: AppAgentActions }) {
	return {
		getCurrentRoute: tool({
			description:
				"Get the current app route (pathname, search, and parsed " +
				"route name). Call when you need to know where the user is " +
				"in the app. Does not include board canvas camera state.",
			inputSchema: z.object({}),
			execute: async () => actions.getCurrentRoute(),
		}),
		navigateApp: tool({
			description:
				"Navigate the authenticated Illumi app to Home, Library, " +
				"Whiteboards list, Trash, Draft, Profile, a whiteboard by " +
				"id, or a card page by id. whiteboardId / cardId may be " +
				"typed (Whiteboard-… / Card-…) or raw; the app strips the " +
				"prefix for the URL. Not for canvas pan/zoom — use " +
				"navigateToCard / navigateToShape on a board. Does not " +
				"auto-open a board after createWhiteboard unless the user " +
				"asked to go there.",
			inputSchema: z
				.object({
					destination: navigateDestinationSchema,
					whiteboardId: z.string().min(1).optional(),
					cardId: z.string().min(1).optional(),
				})
				.superRefine((value, ctx) => {
					if (
						value.destination === "whiteboard" &&
						!value.whiteboardId?.trim()
					) {
						ctx.addIssue({
							code: z.ZodIssueCode.custom,
							message:
								"whiteboardId is required when destination is whiteboard",
							path: ["whiteboardId"],
						});
					}
					if (value.destination === "card" && !value.cardId?.trim()) {
						ctx.addIssue({
							code: z.ZodIssueCode.custom,
							message: "cardId is required when destination is card",
							path: ["cardId"],
						});
					}
				}),
			execute: async (input) => actions.navigateApp(input),
		}),
	};
}
